import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import "../../../styles/main.css"
import App from "./App"
import { store } from "../../../app"
import RootLayout from "../../../shared/Layouts/RootLayout"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("saved-tours-session")
  if (container) {
    const root = createRoot(container)

    console.log("container", container)

    const props = JSON.parse(container.getAttribute("data-props") || "{}")

    root.render(
      <Provider store={store}>
        <RootLayout themeName={props?.themeName ?? "default"}>
          <App {...props} />
        </RootLayout>
      </Provider>
    )
  }
})
